import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-light">
        <Loader2 className="h-6 w-6 animate-spin text-brand-graphite" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
